import React from 'react';
import { motion } from 'framer-motion';
interface AdaptabilitySectionProps {
  onOpenDemo: () => void;
}
export function AdaptabilitySection({
  onOpenDemo
}: AdaptabilitySectionProps) {
  const categories = [{
    name: 'One Restaurant',
    desc: 'Single location focus'
  }, {
    name: 'A Café',
    desc: 'High volume, low margin'
  }, {
    name: 'A Deli',
    desc: 'Inventory & waste control'
  }, {
    name: 'Multiple Locations',
    desc: 'Enterprise consolidation'
  }];
  return <section id="adaptability" className="bg-midnight-navy py-24 md:py-32 overflow-hidden" data-id="element-15">
      <div className="max-w-7xl mx-auto px-6 text-center space-y-16" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-3xl mx-auto space-y-6" data-id="element-17">
          <h2 className="text-stark-white text-4xl md:text-6xl font-manrope font-bold" data-id="element-18">
            Built for Speed.
          </h2>
          <p className="text-stark-white/70 text-xl leading-relaxed" data-id="element-19">
            Most systems take months to implement. ROI is designed to help
            operators start seeing insights quickly so you can make informed
            decisions sooner, not later.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-20">
          {categories.map((cat, idx) => <motion.div key={cat.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: idx * 0.1,
          ease: 'easeOut'
        }} whileHover={{
          y: -5,
          backgroundColor: 'rgba(255, 255, 255, 0.08)'
        }} onClick={onOpenDemo} className="group p-8 border border-white/10 hover:border-accent-red transition-all text-left bg-white/5 cursor-pointer" data-id="element-21">
              <div className="w-12 h-1 bg-accent-red mb-8 group-hover:w-full transition-all duration-500" data-id="element-22" />
              <h3 className="text-stark-white text-xl font-bold mb-2" data-id="element-23">
                {cat.name}
              </h3>
              <p className="text-stark-white/50 text-sm" data-id="element-24">{cat.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}